export const siteSettings = {
  name: "Pro Crypto Desk",
  link: "https://procryptodesk.com",
  email: "support@procryptodesk.com",
  appLink: "https://app.procryptodesk.com",
};
